const init = () => {
    return new Promise<any>((resolve, reject) => {
        resolve( true )
        reject( false )
    }) 
}
export default init